import {AfterViewInit, Component, HostBinding, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {FieldsInterventionsPageRequest} from '../fields-interventions-page/fields-interventions-page-request';
import {FieldsInterventionsNavigationActivatedComponent} from '../fields-interventions-navigation/fields-interventions-navigation-activated-component';
import {Subscription} from 'rxjs';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource, {PivotGridDataSourceField} from 'devextreme/ui/pivot_grid/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';
import {TrailerInterventionService} from '../../stores/trailer-intervention.service';
import {durationToHoursStr} from 'shared';
import FieldsInterventionsReports from './fields-interventions-pivot-grid-reports';
import {find, filter} from 'lodash';
import {UserDomainService} from '../../user-domains/user-domain.service';
import {UserDomain} from '../../user-domains/user-domain';

@Component({
  selector: 'app-fields-interventions-pivot-grid',
  templateUrl: './fields-interventions-pivot-grid.component.html',
  styleUrls: ['./fields-interventions-pivot-grid.component.scss']
})
export class FieldsInterventionsPivotGridComponent extends FieldsInterventionsNavigationActivatedComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  @Input()
  request: FieldsInterventionsPageRequest;

  @Input()
  width: number;

  @Input()
  height: number;

  @Input()
  @HostBinding('hidden')
  hidden: boolean;
  private submitSub: Subscription;
  private hasPendingRequest: boolean;

  ds: DataSource;
  dataSource: PivotGridDataSource;
  store: ArrayStore;

  toolbarDs: DataSource;

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  gridCss: { width: string; height: string };
  reportsDs: DataSource;
  viewModes = [{text: 'Tableau', value: 'pivot'}, {text: 'Chart', value: 'chart'}];
  reportCurrentViewModes = ['pivot'];

  currentReportType = FieldsInterventionsReports[0];

  filterButtonOptions = {
    icon: 'filter',
    text: 'Filtrer',
    onClick: (e: any) => {
      // this.pivotGrid.instance.getFieldChooserPopup().show();
    }
  };
  refreshButtonOptions = {
    icon: 'refresh',
    text: 'Actualiser',
    hint: 'Actualiser',
    onClick: (e: any) => {
      this.dataSource.reload();
    }
  };
  chartHeight: number;
  current: any;

  domains: UserDomain[];

  constructor(
    private trailerInterventionService: TrailerInterventionService,
    private userDomainsService: UserDomainService,
  ) {
    super();

    // User domains
    this.domains = userDomainsService.domains;

    this.ds = this.trailerInterventionService.newDataSource({
      paginate: false,
    });

    this.store = new ArrayStore({
      key: 'id',
      data: [],
    });

    this.reportsDs = new DataSource({
      store: new ArrayStore({
        data: FieldsInterventionsReports,
        key: 'value'
      }),
      group: 'group'
    });

    this.dataSource = new PivotGridDataSource({
      store: this.store,
      retrieveFields: false,
    });
  }

  ngOnInit(): void {
    // Dims
    this.gridCss = {
      width: this.width + 'px',
      height: this.height + 'px',
    };

    this.submitSub = this.request.submit$.subscribe(() => {
      if (this.isActivated) {
        this.loadRequest();
      } else {
        this.hasPendingRequest = true;
      }
    });

    // Toolbar data source
    this.toolbarDs = new DataSource({
      store: new ArrayStore({
        key: 'name',
        data: [
          {name: 'title', location: 'before', locateInMenu: 'never', template: 'toolbarTitle'},
          {name: 'type', location: 'center', locateInMenu: 'never', template: 'toolbarReportTypeSelect'},
          {name: 'view', location: 'center', locateInMenu: 'never', template: 'toolbarReportViewModeSelect'},
          {name: 'filter', location: 'after', locateInMenu: 'never', widget: 'dxButton', options: this.filterButtonOptions},
          {name: 'refresh', location: 'after', locateInMenu: 'never', widget: 'dxButton', options: this.refreshButtonOptions},
        ]
      })
    });
  }

  private loadRequest() {
    // this.pivotGrid.instance.beginUpdate();
    this.store.clear();

    this.ds.filter([
      ['start_time', '>=', this.request.from],
      'and',
      ['start_time', '<=', this.request.to]
    ]);

    /*this.ds.filter([
      ['start_time', '>=', '2020-04-06T23:00:00.000Z'],
      'and',
      ['start_time', '<=', '2021-04-07T22:59:59.999Z']
    ]);*/

    this.ds.load().then((all) => {
      const changes = [];
      all.forEach(i => {
        changes.push({type: 'insert', data: i});
      });
      this.store.push(changes);
      this.dataSource.reload();
      // this.pivotGrid.instance.endUpdate();

      this.hasPendingRequest = false;
    });
  }

  onActivated() {
    if (this.hasPendingRequest) {
      this.loadRequest();
    }
  }

  duration(value) {
    return durationToHoursStr(value) + ' h';
  }

  hectareUnit(value) {
    return value.toFixed(2) + ' ha';
  }

  onDeactivated() {
  }

  ngOnDestroy(): void {
    this.submitSub.unsubscribe();
  }

  reportTypeChanged(e: any) {
    this.currentReportType = e.value;
    /*this.dataSource.fields(e.value.fields);
    this.chartHeight = filter(e.value.fields, (f) => {
      return f.area === 'data' && f.visible !== false;
    }).length * 350;
    this.dataSource.reload();*/
  }

  viewModeClick(e: any) {

  }

  ngAfterViewInit(): void {
    /*this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'splitPanes',
      alternateDataFields: false,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      }
    });*/
  }
}
